import script from "./navbar-dark.vue?vue&type=script&setup=true&lang=js"
export * from "./navbar-dark.vue?vue&type=script&setup=true&lang=js"

import "./navbar-dark.vue?vue&type=style&index=0&id=06834a9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06834a9a"]])

export default __exports__